module.exports = __webpack_public_path__ + "img/Nomi_Cercle.bbd0ab82.png";